import httpClient from '@/api/http-client';

const endpoint = 'api/login-history';

const loginHistoryService = {
  getPage: (params) => httpClient.get(endpoint, { params }),
};

export default loginHistoryService;
